export function validateEmailFormat(email: string): boolean {
  return /.+@.+\..+/gi.test(email);
}

export function getEmailError(email: string) {
  if (!email.trim()) {
    return 'Введите email';
  } else if (!validateEmailFormat(email)) {
    return 'Неверный e-mail адрес';
  }

  return '';
}
